import { useState, useEffect, useMemo } from "react"
import { Table } from "react-bootstrap"
import { defaultSortConfig, formatNumber, fetchSelectors} from "./helpers"

const SummaryTable = ({
  data,
  csvDownloadTracker,
  setSelected,
  setCsvDownloadTracker,
  selected,
  setSelectors,
}) => {
  const [sortConfig, setSortConfig] = useState(defaultSortConfig)

  const sortData = useMemo(() => {
    let sortableItems = [...data]
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1
        }
        return 0
      })
    }
    return sortableItems
  }, [data, sortConfig])

  const requestSort = (key) => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const updateCustomer = async (item) => {
    let sales = [];
    if (item.sales === "multiple") {
      sales = [];
    } else {
      sales = item.sales ? [item.sales] : [];
    }
  
    setSelected((prev) => ({
      ...prev,
      sales: sales,
      customer: [item.customer],
    }));
    // Fetch selectors will update the selector elements
    // since the selectors object is passed as a prop to them
    try {
      fetchSelectors(setSelectors);
    } catch (error) {
      console.error("Error fetching selectors:", error);
    }
  };

  const exportToCsv = () => {
    const csvRows = [
      [
        "Customer",
        "Miles",
        "Orders",
        "Revenue",
        "Cost",
        "Gross Margin",
        "Margin %",
        "Sales",
        "AM",
      ],
      ...sortData.map((item) => [
        `"${item.customer}"`,
        `"${item.miles}"`,
        `"${item.order_count}"`,
        `"${item.revenue}"`,
        `"${item.cost}"`,
        `"${item.margin}"`,
        `"${item.percent}"`,
        `"${item.sales}"`,
        `"${item.AM}"`,
      ]),
    ]
    const csvString = csvRows.map((row) => row.join(",")).join("\n")
    const blob = new Blob([csvString], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.setAttribute("hidden", "")
    a.setAttribute("href", url)
    a.setAttribute(
      "download",
      `all_gross_margin_${selected.start}_${selected.end}`
    )
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    setCsvDownloadTracker(false)
  }

  useEffect(() => {
    if (csvDownloadTracker == true) {
      exportToCsv()
    }
  }, [csvDownloadTracker])

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th onClick={() => requestSort("customer")}>Customer</th>
          <th onClick={() => requestSort("miles")}>Total Miles</th>
          <th onClick={() => requestSort("order_count")}>Orders</th>
          <th onClick={() => requestSort("revenue")}>Total Revenue</th>
          <th onClick={() => requestSort("cost")}>Total Cost</th>
          <th onClick={() => requestSort("margin")}>Gross Margin</th>
          <th onClick={() => requestSort("percent")}>Gross Margin %</th>
          <th onClick={() => requestSort("sales")}>Sales</th>
          <th onClick={() => requestSort("AM")}>AM</th>
        </tr>
      </thead>
      <tbody>
        {sortData.map((item, index) => (
          <tr
            className='gross-margin-row'
            onClick={
              item.customer === "total" ? undefined : () => updateCustomer(item)
            }
            key={index}
          >
            <td>{index + 1}</td>
            <td>{item.customer}</td>
            <td>{formatNumber(item.miles)}</td>
            <td>{formatNumber(item.order_count)}</td>
            <td>${formatNumber(item.revenue)}</td>
            <td>${formatNumber(item.cost)}</td>
            <td>${formatNumber(item.margin)}</td>
            <td>{item.percent}%</td>
            <td>{item.sales}</td>
            <td>{item.AM}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default SummaryTable
